module.exports = "/_next/static/images/62daf595fa3ead824985cf0ef8c23a5b-girl-holding-phone@2x.jpg";